var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33398 4.16667C7.33398 3.59138 7.76448 3.125 8.29553 3.125H14.7058C15.2368 3.125 15.6673 3.59138 15.6673 4.16667C15.6673 4.74196 15.2368 5.20833 14.7058 5.20833H8.29553C7.76448 5.20833 7.33398 4.74196 7.33398 4.16667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18584 21.875H13.8154C17.0666 21.875 18.6921 21.875 19.8598 21.1226C20.3652 20.7969 20.7993 20.3783 21.1371 19.8909C21.9173 18.7649 21.9173 17.1974 21.9173 14.0624C21.9173 10.9274 21.9171 9.3601 21.1369 8.23409C20.7992 7.74662 20.3651 7.32809 19.8596 7.00237C18.6919 6.25 17.0664 6.25 13.8153 6.25H9.18566C5.9346 6.25 4.30906 6.25 3.14136 7.00237C2.63585 7.32809 2.20182 7.74662 1.86405 8.23409C1.08398 9.35986 1.08398 10.9267 1.08398 14.0603V14.0624C1.08398 17.1974 1.08398 18.7649 1.86421 19.8909C2.20198 20.3783 2.63602 20.7969 3.14153 21.1226C4.30923 21.875 5.93476 21.875 9.18584 21.875ZM7.16037 14.0624C7.16037 11.7508 9.10358 9.87704 11.5007 9.87704C13.8977 9.87704 15.841 11.7508 15.841 14.0624C15.841 16.3739 13.8977 18.2477 11.5007 18.2477C9.10358 18.2477 7.16037 16.3739 7.16037 14.0624ZM8.89648 14.0624C8.89648 12.6755 10.0624 11.5511 11.5007 11.5511C12.9389 11.5511 14.1048 12.6755 14.1048 14.0624C14.1048 15.4493 12.9389 16.5735 11.5007 16.5735C10.0624 16.5735 8.89648 15.4493 8.89648 14.0624ZM17.8664 9.87704C17.387 9.87704 16.9984 10.2518 16.9984 10.7141C16.9984 11.1765 17.387 11.5511 17.8664 11.5511H18.4451C18.9245 11.5511 19.3132 11.1765 19.3132 10.7141C19.3132 10.2518 18.9245 9.87704 18.4451 9.87704H17.8664Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCamera);
export default __webpack_public_path__ + "static/media/profileCamera.f4368d95adf190d600be56fd90edebfe.svg";
export { ForwardRef as ReactComponent };